<template>
    <div class="must-have-exactly-one-root-element">

        <!-- Header -->
        <header-profil
            @updateProfil="emitUpdateProfil"
            :profil="profil"
        />

        <!-- Main -->
        <main class="profileDashboard">
            <div class="container">
                <div class="row">

                    <!-- Menu -->
                    <menu-profil
                        :profil="profil"
                        :spravy="spravy"
                    />

                    <!-- Údaje kravičky -->
                    <div v-if="profil.pouzivatel_id" class="col-xs-12 col-md-12 col-lg-8 col-xl-9">
                        <!-- *Preloader box -->
                        <h2 v-if="!kravicka_title">Meno kravičky</h2> 
                        <!-- *Content -->
                        <h2 v-else>{{ kravicka_title }}</h2> 

                        <!-- Alert box -->
                        <div v-if="responseText != ''" :class="'alert alert-'+responseType" role="alert">
                            <span :class="'icon --'+responseType"></span>{{ responseText }}
                        </div>

                        <!-- Form Box -->
                        <form @submit="formSubmit">
                            <div class="form-row">
                                <div class="col-xs-12 col-md-6">
                                    <label>Meno kravičky</label>
                                    <input type="text" class="form-control" v-model="kravicka_meno">
                                </div>   
                                <div class="col-xs-12 col-md-6"></div>                         
                            </div>

                            <div class="form-row">
                                <div class="col-xs-12 col-md-6">
                                    <label>Meno majiteľa</label>
                                    <input type="text" class="form-control" v-model="kravicka_meno_rodica">
                                </div>
                                <div class="col-xs-12 col-md-6"></div>
                            </div>

                            <div class="form-row">
                                <div class="col-xs-12 col-md-6">
                                    <button type="submit" class="btn --primary">Upraviť údaje <span class="icon"></span></button>
                                </div>
                            </div>
                        </form>
                        <!-- .Form Box -->

                    </div>
                    <!-- .Údaje kravičky -->

                </div>
            </div>
        </main>

    </div>
</template>



<script>
    import EventService from '@/services/EventService.js'
    import HeaderProfil from '../partials/HeaderProfil.vue'
    import MenuProfil   from '../partials/MenuProfil.vue'
    export default {
        components: {
            HeaderProfil,
            MenuProfil
        },
        props: [
            'profil',
            'spravy'
        ],
        mounted() {
            //console.log(this.$route.params)
            this.checkKravickaInfo()
        },
        data() {
            return {
                kravicka_id:    this.$route.params.kravicka_id,
                kravicka_title: this.$route.params.kravicka_meno,
                kravicka_meno:  this.$route.params.kravicka_meno,
                kravicka_meno_rodica: this.$route.params.kravicka_meno_rodica,

                responseType: '',
                responseText: ''
            }
        },
        methods: {
            // emit
            emitUpdateProfil() {
                if (typeof(this.profil.id) == "undefined" || this.profil.id == 0) {
                    this.$emit('updateProfil')
                }
            },


            // mounted
            checkKravickaInfo() {
                if (typeof(this.kravicka_meno) == 'undefined') {
                    EventService.getKravickaInfo(this.$route.params.kravicka_id)
                        .then(response => {
                            //console.log(response.data)
                            // fix ak príde response s chybovou hláškou (Undefined index: ean_kravicky)
                            /*if (typeof(response.data) == 'string') {
                                var toj = response.data.split("<br />")
                                var obj = JSON.parse(toj[0])
                                //console.log(obj.data[0])
                                response.data = obj
                            }*/
                            this.kravicka_title = response.data.data.kravicka_meno
                            this.kravicka_meno  = response.data.data.kravicka_meno
                            this.kravicka_meno_rodica = response.data.data.kravicka_meno_rodica
                        })
                        .catch(error => {
                            this.responseType = 'warning'
                            this.responseText = error
                        })
                }
            },


            // submit
            formSubmit(e) {
                e.preventDefault()
                this.changeKravickaInfo()
            },

            changeKravickaInfo() {
                EventService.changeKravickaInfo(this.kravicka_id, this.kravicka_meno, this.kravicka_meno_rodica)
                    .then(response => {
                        //console.log(response.data)
                        this.responseType = 'success'
                        this.responseText = 'Údaje boli úspešne zmenené'

                        this.kravicka_title = this.kravicka_meno

                        for (var i = 0; i < this.profil.pouzivatel_id.kravicky_pouzivatela.length; i++) {
                            if (this.profil.pouzivatel_id.kravicky_pouzivatela[i].id == this.kravicka_id) {
                                this.profil.pouzivatel_id.kravicky_pouzivatela[i].kravicka_meno = this.kravicka_meno
                                this.profil.pouzivatel_id.kravicky_pouzivatela[i].kravicka_meno_rodica = this.kravicka_meno_rodica
                            }
                        }
                        this.$emit('update:profil', this.profil)
                    })
                    .catch(error => {
                        this.responseType = 'warning'
                        this.responseText = error
                    })
            }
        }
    }
</script>